import $ from 'jquery'

/**
 * @typedef {function} DatepickerAdapterOn - The on method of the datepicker adapter
 * @param {string} eventName - The event to listen for
 * @param {function} callback - The callback to call when the event is triggered
 * @returns {function} - The off method of the datepicker adapter
 */

/**
 * @typedef {Object} DatepickerAdapter - Adapter for JQuery's datepicker method
 * @property {function} execute - Executes commands on the datepicker plugin
 * @property {DatepickerAdapterOn} on - Adds an event listener to the datepicker plugin
 */

/**
 * Adapter for Bootstrap's Datepicker plugin.
 * @param {HTMLElement} element - The element to which the datepicker is applied.
 * @param {Object} options - Options for the datepicker plugin.
 * @returns {DatepickerAdapter} - The datepicker adapter.
 */
export default (element, options) => {
  const $el = $(element)
  const datepicker = $el.datepicker(options)

  return {
    execute: (commandName, options) => {
      $el.datepicker(commandName, options)
    },
    on: (eventName, callback) => {
      datepicker.on(eventName, callback)

      return () => {
        datepicker.off(eventName, callback)
      }
    },
  }
}
